import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import conversationService from "@/services/conversation.service";
import { CreateRequestProps } from "@/types/requests.types";

export type StartConversationData = {
  contactId: number;
  platformId: number;
};

export type StartConversationProps = CreateRequestProps<StartConversationData>;

export type UseStartConversationReturn = {
  startConversation: (props: StartConversationProps) => Promise<void>;
} & UseLoadingReturn;

const useStartConversation = (): UseStartConversationReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<StartConversationData>({
      operation: (formData) =>
        conversationService.startConversation(formData.contactId, formData.platformId),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    startConversation: create,
  };
};

export default useStartConversation;

